import * as React from 'react';
import NavHelper from '../components/NavHelper';

class WhatWeDo extends React.PureComponent {
  render(): JSX.Element {
    return (
      <div>
        <NavHelper pageName="What We Do" icon="fa-graduation-cap" />
        <section id="main-content" className="main-content pad-60">
          <div className="container">
            <div className="row">
              <div className="col-sm-4 col-xs-12">
                <img src="assets/images/what/graduation.jpg" className="img-responsive" alt="volunteer-2" />
              </div>
              <div className="col-sm-8 col-xs-12">
                <div className="article pad-b-60">
                  <h2>Girl and Education</h2>
                  <p>PRO-EMA aims to keep girls and young women in education by creating an enabling environment, to empower them with relevant  knowledge and skills, to ensure they are healthy and make informed decisions about their life, to support them to make successful and healthy  transitions into adulthood and the labour market, and to fully participate in society.
                  </p>
                  <p>Through professional training and follow-up of a coaching, the beneficiaries will have access to professional technical courses, which will include theoretical and practical classes. Giving them tools and developing skills to work in the labor market. The purpose of the personal coaching/mentoring is to prepare these adolescents for the normal and independent living, after leaving the program.</p>
                </div> {/*/.article*/}
              </div>
            </div> {/*/.row*/}
            <div className="row">
              <div className="col-sm-8 col-xs-12">
                <div className="article">
                  <h2>Where We Work</h2>
                  <p>Situated on the very rim of Asia’s south-east, the country of Timor-Leste is one of the region’s poorest and least developed. Having gained democratic independence just 16 years ago, after centuries of occupation, the largely Roman Catholic nation is still very much in recovery and a state of painstaking renewal.</p>
                  <p>
                    Despite the constraints of being newly independent and one of the poorest countries in the world, Timor Leste has joined the global effort to achieve the Millennium Development Goals, including the goal of promoting gender equality and empowering women.
                  </p>
                </div> {/*/.article*/}
              </div>
              <div className="col-sm-4 col-xs-12">
                <img src="assets/images/what/kitchen.jpg" className="img-responsive" alt="volunteer-2" />
              </div>
            </div> {/*/.row*/}
          </div> {/*/.container*/}
        </section>
      </div>);
  }
}

export default WhatWeDo;



// WEBPACK FOOTER //
// ./src/page/WhatWeDo.tsx